import { isDefinedNonNull } from "src/utils/validate_util";

type JQueryAjaxResult<T> = {
  data: T;
  textStatus: JQuery.Ajax.SuccessTextStatus;
  jqXHR: JQuery.jqXHR<T>;
};

// JQuery.Promise を標準の Promise に変換します。
export const convertJQueryPromiseToPromise = <T>(
  jqueryPromise: JQuery.Promise<T>
): Promise<JQueryAjaxResult<T>> => {
  return new Promise((resolve, reject) => {
    jqueryPromise
      // JQuery.Promise は resolve 時に複数値を返却できますが、型を明確にできるのは 1 つ目の値（data）のみのようです。
      // そのため textStatus と jqXHR の型は any になります。
      // （一方、JQuery.jqXHR は JQuery.Promise3 を継承しているため、複数値の型を明確にできるようです。）
      .done((data, textStatus: any, jqXHR: any) => {
        resolve({ data, textStatus, jqXHR });
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        reject({ jqXHR, textStatus, errorThrown });
      });
  });
};

export const setupXhr = (options: any) => {
  var xhr = new window.XMLHttpRequest();

  xhr.upload.addEventListener(
    "progress",
    function (evt) {
      if (evt.lengthComputable) {
        var percent = (evt.loaded / evt.total) * 100;
        if (isDefinedNonNull(options) && options.uploadProgress) {
          options.uploadProgress(percent);
        }
      }
    },
    false
  );
  xhr.addEventListener(
    "progress",
    function (evt) {
      if (evt.lengthComputable) {
        var percent = (evt.loaded / evt.total) * 100;
        if (isDefinedNonNull(options) && options.downloadProgress) {
          options.downloadProgress(percent);
        }
      }
    },
    false
  );

  return xhr;
};
